<template>
  <div class="dual-range-slider">
    <div class="slider-wrapper">
      <!-- šedý podklad -->
      <div class="track"></div>
      <!-- modrý vybraný úsek -->
      <div class="selected-track" :style="selectedTrackStyle"></div>

      <!-- spodní roubek -->
      <input
          class="thumb thumb--lower"
          type="range"
          :min="min"
          :max="max"
          :step="step"
          v-model.number="local[0]"
          @input="onInput('lower')"
          @change="emitChange"
      />
      <!-- horní roubek -->
      <input
          class="thumb thumb--upper"
          type="range"
          :min="min"
          :max="max"
          :step="step"
          v-model.number="local[1]"
          @input="onInput('upper')"
          @change="emitChange"
      />
    </div>

    <!-- bublinky s hodnotami -->
    <div class="labels">
      <div class="thumb-label">
        {{ format(local[0]) }}
      </div>
      <div class="thumb-label">
        {{ format(local[1]) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDualRangeSlider } from '@/composables/useDualRangeSlider'

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  min:        { type: Number, required: true },
  max:        { type: Number, required: true },
  step:       { type: Number, required: true },
  format:     { type: Function, default: v => v.toString() },
})
const emit = defineEmits(['update:modelValue'])

// Use the composable for shared logic
const {
  local,
  onInput,
  emitChange,
  selectedTrackStyle
} = useDualRangeSlider(props, emit)
</script>

<style scoped>
.dual-range-slider {
  position: relative;
  width: 100%;
}

.slider-wrapper {
  position: relative;
  height: 30px;             /* výška pro slider */
  margin-bottom: 8px;       /* prostor mezi sliderem a labely */
}

/* 1) šedá linka */
.track {
  position: absolute;
  top: 50%; left: 0;
  width: 100%; height: 4px;
  background: #e5e5e5;
  transform: translateY(-50%);
  border-radius: 2px;
  z-index: 1;
}

/* 2) modrý vybraný úsek */
.selected-track {
  position: absolute;
  top: 50%; left: 0;
  height: 4px;
  background: var(--bs-primary);
  transform: translateY(-50%);
  border-radius: 2px;
  z-index: 2;
}

/* 3) oba range inputy */
.thumb {
  -webkit-appearance: none;
  position: absolute;
  top: 50%; left: 0;         /* Align with the track */
  width: 100%; height: 30px; /* Fixed height for better control */
  margin-top: -15px;         /* Center the touch area on the track */
  background: transparent;
  pointer-events: none;      /* Important: disable pointer events on the track */
  cursor: pointer;
}

/* Specific z-index for each thumb to ensure proper layering */
.thumb--lower { z-index: 3; }
.thumb--upper { z-index: 4; }

/* aktivní rouček nad ostatními */
.thumb:hover, .thumb:active {
  z-index: 5;
}

/* kolečko (WebKit) */
.thumb::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px; height: 16px;
  background: #fff;
  border: 2px solid var(--bs-primary);
  border-radius: 50%;
  cursor: pointer;
  pointer-events: auto;      /* Enable pointer events on the thumb */
}

/* kolečko (Firefox) */
.thumb::-moz-range-thumb {
  width: 16px; height: 16px;
  background: #fff;
  border: 2px solid var(--bs-primary);
  border-radius: 50%;
  cursor: pointer;
  pointer-events: auto;      /* Enable pointer events on the thumb */
}

/* 4) bublinky s hodnotami */
.labels {
  display: flex;
  justify-content: space-between;
  width: 100%;
  pointer-events: none;     /* neblokují myš */
  margin-top: 0.5rem;       /* odsazení od slideru */
}
.thumb-label {
  background: var(--bs-primary);
  color: #fff;
  padding: 4px 8px;
  font-size: 0.75rem;
  border-radius: 0.5rem;
  white-space: nowrap;
  min-width: 30px;
  text-align: center;
  z-index: 6;
}
</style>
